<template>
    <div>
        <loading ref="loading"></loading>
        <div class="container" id="container" v-if="isAlreadyLoading">
            <Header></Header>
            <div class="page input home  js_show">
                <div class="page__bd">
                    <div class="enrollment-banner">
                        <img src="@/assets/images/enrollment_banner.jpg" alt="pic">
                    </div>
                    <div id="server-message" class="server_back_error_message" v-show="server_back_error_message_show">
                        <div class="server_back_error_message_img">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <p class="server_back_error_message_content" v-html="errorNotice"></p>
                    </div>
                    <form class="Sign_Up_Form">
                        <div class="weui-cells_form enrollment-content">
                            <div class="admin-title">
                                <img src="@/assets/images/admin.png" alt="pic">
                                <span>账户信息</span>
                            </div>
                            <div class="name-box">
                                <div class="input-box" :style="{marginBottom: isRightLastname ? '23px' : '14px'}" :class="{'checkName': isLastnameEmpty}">
                                    <input class="weui-input" v-on:change="translateLastName" v-validate="'required|CN_name|'" type="text" name="lastname" placeholder="中文姓氏" autocomplete="last-name" v-model="lastnameVal"  maxlength="35">
                                    <span v-show="errors.has('lastname')" class="error_message help is-danger">{{ errors.first('lastname') }}</span>
                                </div>
                                <div class="input-box" :style="{marginBottom: isRightLastname ? '23px' : '14px'}" :class="{'checkName': isLastnameEmpty}">
                                    <input class="weui-input" v-validate="'required|alpha_spaces'" type="text" name="lastnameLatin" placeholder="姓氏用拼音输入" autocomplete="last-name" @blur="judgeLastnameValue" v-model="lastnameLatinVal" maxlength="35">
                                    <span v-show="errors.has('lastnameLatin')&&isLatinLastname" class="error_message help is-danger">{{ errors.first('lastnameLatin') }}</span>
                                </div>
                                <div class="input-box" :style="{marginBottom: isRightFirstname ? '23px' : '14px'}" :class="{'checkName':  isFirstnameEmpty}">
                                    <input class="weui-input" v-on:change="translateFirstName" v-validate="'required|CN_name'" type="text" name="firstname" placeholder="中文名字" autocomplete="first-name" v-model="firstnameVal" maxlength="30">
                                    <span v-show="errors.has('firstname')" class="error_message help is-danger">{{ errors.first('firstname') }}</span>
                                </div>
                                <div class="input-box" :style="{marginBottom:isRightFirstname ? '23px' : '14px'}" :class="{'checkName':  isFirstnameEmpty}">
                                    <input class="weui-input" v-validate="'required|alpha_spaces'" type="text" name="firstnameLatin" placeholder="名字用拼音输入" autocomplete="first-name" @blur="judgeFirstnameValue" v-model="firstnameLatinVal" maxlength="30">
                                    <span v-show="errors.has('firstnameLatin')&&isLatinFirstname" class="error_message help is-danger">{{ errors.first('firstnameLatin') }}</span>
                                </div>
                            </div>
                            <div class="input-box">
                                <div class="weui-cell__bd">
                                    <input class="weui-input" v-validate="'required|email_validate'" type="email" name="email" placeholder="电子邮箱地址" autocomplete="email" v-model="emailAddressVal" maxlength="75">
                                    <span v-show="errors.has('email')" class="error_message help is-danger">{{ errors.first('email') }}</span>
                                </div>
                            </div>
                            <div class="input-box">
                                <div class="phone-select-box">
                                    <label>{{selected}}
                                        <el-select v-model="selected" placeholder="请选择" :class="{'selectBox': isSelect}">
                                            <el-option-group
                                                v-for="group in groupList"
                                                :key="group.label"
                                                :label="group.label">
                                                <el-option
                                                    v-for="(countrycode, index) in group.options"
                                                    :key="index"
                                                    :label="countrycode.countryName"
                                                    :value="countrycode.countryCode">
                                                </el-option>
                                            </el-option-group>
                                        </el-select>
                                    </label>
                                </div>
                                <div class="phone-input-box">
                                    <input class="weui-input" v-validate="`numeric${selected === '+86'?'|min:11|max:11': ''}`" type="tel" name="phone" placeholder="手机号码" autocomplete="phone" v-model="phoneVal" maxlength="20">
                                </div>
                                <div v-show="phone_error_message">
                                    <span v-show="errors.has('phone')" class="error_message help is-danger">{{ errors.first('phone') }}</span>
                                </div>
                            </div>
                            <div class="input-box">
                                <div class="weui-cell__bd">
                                    <input class="weui-input" v-model="pin_1_value" v-validate="'required|numeric|min:4|confirmed_pin|confirmed_pin_equal'" minlength="4" maxlength="4" :type="pinType" name="pin_1" placeholder="创建密码(4位数字)" autocomplete="password" style="-webkit-text-security:disc" @blur="createPin">
                                    <span v-show="errors.has('pin_1')" class="error_message help is-danger">{{ errors.first('pin_1') }}</span>
                                </div>
                            </div>
                            <div class="input-box">
                                <div class="weui-cell__bd">
                                    <input class="weui-input" v-validate="'required|numeric|min:4|confirmed_pin|confirmed_pin_equal'" maxlength="4" type="tel" name="pin_2" placeholder="再一次输入密码"  autocomplete="confirmed-password" style="-webkit-text-security:disc" v-model="pin_2_value" @blur="validatePin">
                                    <span v-show="errors.has('pin_2')&&errorPinValidate" class="error_message help is-danger">{{ errors.first('pin_2') }}</span>
                                </div>
                            </div>
                            <div class="weui-cell input-box region-box">
                                <div class="weui-cell__bd">
                                    <label>{{selectedRegion}}
                                        <el-select v-model="selectedRegion" placeholder="请选择国家/地区" class="region-select">
                                            <el-option
                                                v-for="(item, index) in options"
                                                :label="item.label"
                                                :key="index"
                                                :value="item.label"
                                                :disabled="item.disabled">
                                            </el-option>
                                        </el-select>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <a class="foreign_country_region_link" href="https://www.ihg.com/rewardsclub/cn/zh/join/register" @click="storeFormData">境外国家/地区</a>
                        <label for="weuiAgree" class="weui-agree">
                            <input id="weuiAgree" type="checkbox" checked="true" v-model="policy_checkbox" class="weui-agree__checkbox" name="">
                            <span class="weui-agree__text">我保证我已年满18岁并已达到法定年龄，而且已阅读并同意<a href="https://www.ihg.com/content/cn/zh/customer-care/member-tc.html" @click="storeFormData">会员条款与附则</a><span class="weui-agree__fullstop">。</span></span>
                        </label>
                        <div class="weui-btn-area">
                            <button class="weui-btn" @click="validateBeforeSubmit" :disabled="errors.any()||isButtonDisabled" type="button">立即加入</button>
                        </div>
                    </form>
                </div>
                <div class="page__ft"></div>
            </div>
        </div>
    </div>
</template>

<script>
import loading from "@/components/loading";
import Header from "@/components/Header";
import { getCountryCode , sendEnrollmentFrom, getPinYinTranslation, getCsrfToken } from "@/api/index";
import { setStorage, getStorage } from '@/alias/store';
import Vue from "vue";
import cn from "@/assets/js/zh_CN";
import VeeValidate, { Validator } from "vee-validate";
import MtaH5 from 'mta-h5-analysis';

const dict = {
    custom: {
        lastname: {
            required: "请输入您的中文姓氏",
            CN_name: "请输入您正确的姓氏"
        },
        firstname: {
            required: "请输入您的中文名字",
            CN_name: "请输入您正确的名字"
        },
        lastnameLatin: {
            required: "请输入您的姓氏拼音",
            alpha_spaces: "请输入正确的姓氏拼音"
        },
        firstnameLatin: {
            required: "请输入您的名字拼音",
            alpha_spaces: "请输入正确的名字拼音"
        },
        email: {
            required: "请输入您的电子邮箱地址",
            email_validate: "请输入正确的电子邮箱地址"
        },
        phone: {
            numeric: "输入的手机号码格式有误",
            min: "输入的手机号码格式有误",
            max: "输入的手机号码格式有误"
        },
        pin_1: {
            required: "请创建4位数字的密码",
            numeric: "输入的密码必须是4位数字",
            min: "输入的密码必须是4位数字",
            confirmed: "两次输入的密码不一致"
        },
        pin_2: {
            required: "请再次输入密码",
            numeric: "输入的密码必须是4位数字",
            min: "输入的密码必须是4位数字",
            confirmed: "两次输入的密码不一致"
        }
    }
};
Validator.extend('email_validate', {
    getMessage: (field, [args]) => '请输入正确的电子邮箱地址',
    validate: (value, [args]) =>{
        const reg = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_]{3,6}$)+/;
        return reg.test(value)
    }
});
Validator.extend("CN_name", {
    getMessage: (field, [args]) => "请输入您正确的姓氏",
    validate: (value, [args]) => {
        const reg = /^([a-zA-Z\u4e00-\u9fa5 ]+|[a-zA-Z\u4e00-\u9fa5 ]+)$/;
        return reg.test(value);
    }
});

Validator.localize("cn", cn);
Validator.localize("cn", dict);

const config = {
    delay: 10,
    events: "blur"
};
Vue.use(VeeValidate, config);

export default {
    name: "sign-up",
    data() {
        return {
            infoData: {},
            isAlreadyLoading: false,
            server_back_error_message_show: false,
            unclick: true,
            pin_1_value: "",
            pin_2_value: "",
            selected: "86",
            CountryCodeList: {},
            phone_error_message: true,
            policy_checkbox: true,
            isLastnameEmpty: false,
            isFirstnameEmpty: false,
            isRightLastname: false,
            isRightFirstname: false,
            lastnameVal: "",
            firstnameVal: "",
            lastnameLatinVal: "",
            firstnameLatinVal: "",
            emailAddressVal: "",
            phoneVal: "",
            pinType: "tel",
            isLatinLastname: true,
            isLatinFirstname: true,
            errorNotice: '',
            errorPinCreate: false,
            errorPinValidate: false,
            options: [{
                value: 0,
                label: "请选择国家/地区",
                disabled: true
            },
            {
                value: 'CN',
                label: "中国大陆"
            },
            {
                value: 'HK',
                label: "香港"
            },
            {
                value: 'MO',
                label: "澳门"
            },
            {
                value: 'TW',
                label: "台湾"
            }],
            selectedRegion: "中国大陆",
            groupList: [{
                label: "地区",
                options: []
            },
            {
                label: "国家地区",
                options: []
            }],
            csrfToken: ''
        };
    },
    components: {
        loading,
        Header
    },
    methods: {
        storeFormData() {
            let formData = {
                lastnameVal: this.lastnameVal,
                lastnameLatinVal: this.lastnameLatinVal,
                firstnameVal: this.firstnameVal,
                firstnameLatinVal: this.firstnameLatinVal,
                emailAddressVal: this.emailAddressVal,
                selected: this.selected,
                phoneVal: this.phoneVal,
                pin_1_value: this.pin_1_value,
                pin_2_value: this.pin_2_value,
                selectedRegion: this.selectedRegion
            }
            console.log(formData);
            localStorage.setItem('data',JSON.stringify(formData))
        },
        collectFormData() {
            let region = this.selectedRegion;
            let option = this.options;
            let selectRegion = '';
            for(let i = 0, len = option.length; i < len; i++) {
                if(region === option[i].label) {
                    selectRegion = option[i].value
                }
            }
            return {
                'lastName': this.lastnameVal,
                'firstName': this.firstnameVal,
                'lastNameLatin': this.lastnameLatinVal,
                'firstNameLatin': this.firstnameLatinVal,
                'emailAddress': this.emailAddressVal,
                'phone': this.phoneVal,
                'icc': this.phoneVal != ''?this.selected.replace('+', ''): '',
                'pin': this.pin_1_value,
                'country': selectRegion,
                'wxMpUser': this.infoData
            }
        },
        CountryCode: async function() {
            let CountryCode = await getCountryCode();
            this.CountryCodeList = CountryCode;
            this.groupList[0].options = this.CountryCodeList.slice(0, 4);
            this.groupList[1].options = this.CountryCodeList.slice(5);
            this.isAlreadyLoading = true;
            this.$refs.loading.isLoading = false;
            document.getElementById("loading").style.display = 'none';
        },
        judgeLastnameValue() {
            this.isLastnameEmpty = this.lastnameLatinVal === "" ? true : false;
            this.isLatinLastname = true;
            const reg = /^([a-zA-Z ]+)$/;
            if(reg.test(this.lastnameLatinVal)){
                this.isRightLastname = false;
            } else {
                this.isRightLastname = true;
            }
        },
        judgeFirstnameValue() {
            this.isFirstnameEmpty = this.firstnameLatinVal === "" ? true : false;
            this.isLatinFirstname = true;
            const reg = /^([a-zA-Z ]+)$/;
            if(reg.test(this.firstnameLatinVal)){
                this.isRightFirstname = false;
            } else {
                this.isRightFirstname = true;
            }
        },
        validateBeforeSubmit: async function() {
            let regOfNameCN = /^([a-zA-Z\u4e00-\u9fa5 ]+|[a-zA-Z\u4e00-\u9fa5 ]+)$/,
            regOfNameEn = /^([a-zA-Z ]+)$/,
            regOfTel = /^1\d{10}$/,
            regOfEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_]{3,6}$)+/,
            regOfPin = /^\d{4}$/;
            if(!regOfNameCN.test(this.lastnameVal)) {
                return
            } else if(!regOfNameEn.test(this.lastnameLatinVal)) {
                return
            } else if(!regOfNameCN.test(this.firstnameVal)) {
                return
            } else if(!regOfNameEn.test(this.firstnameLatinVal)) {
                return
            } else if(!regOfEmail.test(this.emailAddressVal)) {
                return
            } else if(this.phoneVal !== ''&& this.selected === '+86' && !regOfTel.test(this.phoneVal)) {
                return
            } else if(!regOfPin.test(this.pin_1_value)) {
                return
            } else if(!regOfPin.test(this.pin_2_value)) {
                return
            } else if(this.pin_1_value !== this.pin_2_value ) {
                return
            } else {
                this.$refs.loading.isLoading = true;
                localStorage.removeItem('data');
                let parm = this.collectFormData();
                let enrollmentData = await sendEnrollmentFrom(parm, this.csrfToken);
                if(enrollmentData.statusCode == 1){
                    let userProfile = enrollmentData.data.memberProfileData;
                    let ssoToken = enrollmentData.data.ssoTokenInfoData;
                    setStorage('ssoToken',JSON.stringify(ssoToken));
                    //注册请求成功事件上报
                    MtaH5.clickStat("signup_success")
                    this.$router.replace({
                        name: 'Profile',
                        params: {
                            userProfile : userProfile
                        }
                    });
                    //注册成功跳转至详情页事件上报
                    MtaH5.clickStat("signup_success_to_profile")
                } else if(enrollmentData.statusCode == 0){
                    window.location.assign(enrollmentData.redirectUrl);
                } else {
                    this.errorNotice = enrollmentData.message;
                    this.server_back_error_message_show = true;
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    this.toGetCsrfToken();
                }

                this.$refs.loading.isLoading = false;
            }
        },
        translateLastName: async function() {
            const reg = /^([a-zA-Z\u4e00-\u9fa5 ]+|[a-zA-Z\u4e00-\u9fa5 ]+)$/;
            if(reg.test(this.lastnameVal) || this.lastnameVal == '') {
                let param = { "text" : this.lastnameVal };
                let res = await getPinYinTranslation(param);
                this.lastnameLatinVal = res.translation;
            };
            this.checkLastNameInput();
            const reg_latin = /^([a-zA-Z ]+)$/;
            this.isLastnameEmpty = false;
            this.isLatinLastname =  !reg_latin.test(this.lastnameLatinVal) ? true : false;
        },
        translateFirstName: async function() {
            const reg = /^([a-zA-Z\u4e00-\u9fa5 ]+|[a-zA-Z\u4e00-\u9fa5 ]+)$/;
            if(reg.test(this.firstnameVal) || this.firstnameVal == '') {
                let param = { "text" : this.firstnameVal };
                let res = await getPinYinTranslation(param);
                this.firstnameLatinVal = res.translation;
            };
            this.checkFirstNameInput();
            const reg_latin = /^([a-zA-Z ]+)$/;
            this.isFirstnameEmpty = false;
            this.isLatinFirstname = !reg_latin.test(this.firstnameLatinVal) ? true : false
        },
        toGetCsrfToken: async function() {
            this.csrfToken = await getCsrfToken();
        },
        validatePin() {
            if(this.pin_1_value.length !== 4) {
                this.errorPinCreate = true;
            }else {
                this.errorPinCreate = false;
            }
            if(this.pin_2_value.length !== 4) {
                this.errorPinValidate = true;
            }else{
                this.errorPinValidate = false;
            }
            this.checkSecondPinInput();
        },
        createPin() {
            if(this.pin_1_value.length !== 4) {
                this.errorPinCreate = true;
            }else {
                this.errorPinCreate = false;
            }
            if(this.pin_2_value.length !== 4) {
                this.errorPinValidate = true;
            }else{
                this.errorPinValidate = false;
            }
            this.checkFirstPinInput();
        },
        checkLastNameInput() {
            if (this.firstnameVal != "" && this.firstnameLatinVal != "" && this.emailAddressVal != "") {
                this.$validator.validateAll();
            }
        },
        checkFirstNameInput() {
            if (this.lastnameVal != "" && this.lastnameLatinVal != "" && this.emailAddressVal != "") {
                this.$validator.validateAll();
            }
        },
        checkFirstPinInput() {
            if (this.pin_2_value != "" && this.lastnameVal != "" && this.lastnameLatinVal != "" && this.firstnameVal != "" && this.firstnameLatinVal != "" && this.emailAddressVal != "") {
                this.$validator.validateAll();
            }
        },
        checkSecondPinInput() {
            if (this.pin_1_value != "" && this.lastnameVal != "" && this.lastnameLatinVal != "" && this.firstnameVal != "" && this.firstnameLatinVal != "" && this.emailAddressVal != "") {
                this.$validator.validateAll();
            }
        }
    },
    computed: {
        isButtonDisabled: function() {
            if (
                this.lastnameVal === "" ||
                this.firstnameVal === "" ||
                this.lastnameLatinVal === "" ||
                this.firstnameLatinVal === "" ||
                this.emailAddressVal === "" ||
                this.pin_1_value === "" ||
                this.pin_2_value === "" ||
                this.policy_checkbox === false ||
                this.errorPinCreate === true ||
                this.errorPinValidate === true
            ) {
                return true;
            } else {
                this.server_back_error_message_show = false;
                return false;
            }
        },
        // isRightLastname: function() {
        //     const reg = /^([a-zA-Z ]+)$/;
        //     return !reg.test(this.lastnameLatinVal) && this.lastnameLatinVal !== "" ? true : false
        // },
        // isRightFirstname: function() {
        //     const reg = /^([a-zA-Z ]+)$/;
        //     return !reg.test(this.firstnameLatinVal) && this.firstnameLatinVal !== "" ? true : false
        // },
        isSelect: function() {
            this.selected = `+${this.selected}`;
            return true;
        }
    },
    mounted() {
        let formData = JSON.parse(localStorage.getItem('data'));
        MtaH5.pgv();
        MtaH5.clickStat('sintosuptopro',{'signuppage':'true'});
        if(document.getElementById("loading").style.display === 'block') {
            this.$refs.loading.isLoading = false;
        } else {
            this.$refs.loading.isLoading = true;
        }
        this.toGetCsrfToken();
        if(formData) {
            this.lastnameVal = formData.lastnameVal;
            this.lastnameLatinVal = formData.lastnameLatinVal;
            this.firstnameVal = formData.firstnameVal;
            this.firstnameLatinVal = formData.firstnameLatinVal;
            this.emailAddressVal = formData.emailAddressVal;
            this.selected = formData.selected.replace('+', '');
            this.phoneVal = formData.phoneVal;
            this.pin_1_value = formData.pin_1_value;
            this.pin_2_value = formData.pin_2_value;
            this.selectedRegion = formData.selectedRegion;
        }
        this.infoData = JSON.parse(sessionStorage.getItem('userInfo'));
        this.$refs.loading.isLoading = true;
        this.CountryCode();
        this.$validator.validateAll();
        Validator.extend("confirmed_pin", {
            getMessage: (field, [args]) => "两次输入的密码不一致",
            validate: (value, [args]) => {
                if(this.pin_1_value === ''|| this.pin_2_value === '') {
                    return true
                } else {
                    // this.errorPinCreate = this.pin_1_value === this.pin_2_value ? false : true;
                    this.errorPinCreate = false;
                    this.errorPinValidate = this.pin_1_value === this.pin_2_value ? false : true;
                    return this.pin_1_value === this.pin_2_value ? true : false;
                }
            }
        });
        Validator.extend("confirmed_pin_equal", {
            getMessage: (field, [args]) => "两次输入的密码不一致",
            validate: (value, [args]) => {
                if (this.pin_2_value === '' || this.pin_1_value === '') {
                    return true;
                } else {
                    // this.errorPinCreate = this.pin_1_value === this.pin_2_value ? false : true;
                    this.errorPinCreate = false;
                    this.errorPinValidate = this.pin_1_value === this.pin_2_value ? false : true;
                    return this.pin_2_value === this.pin_1_value ? true : false;
                }
            }
        });
        window.addEventListener("popstate", function(e) {
            localStorage.removeItem('data');
        }, false);
    }
};
</script>

<style scope lang="sass">
.weui-cells
  margin-top: 0;
  background: #efefef;

html, body
  .page
    background: #efefef;
    .enrollment-banner
      img
        height: 120px;
        width: 100%;
    .server_back_error_message
        width: 90%;
        margin: 20px auto 40px;
        background: #ffffff;
        border-radius: 5px;
        .server_back_error_message_img
            padding: 10px 0;
            text-align: center;
            img
                width: 10%;
        .server_back_error_message_content
            color: red;
            width: 90%;
            margin: 0 auto;
            padding-bottom: 25px;
            font-size: 16px;
            font-weight: bold;
            text-align: justify;
    .enrollment-content
      width: 90%;
      margin: 20px auto 0;
      .admin-title
        padding-bottom: 15px;
        img
          width: 7%;
          margin-right: 4px
        span
          font-size: 18px;
          vertical-align: 1px;
          color: #707372;
          font-weight: 600;
    .name-box
      .input-box
        width: 44%;
        height: 45px;
        border: 1px solid #ccc;
        background: #ffffff;
        border-radius: 5px;
        display: inline-block;
        margin-bottom: 14px;
        padding: 0 2%;
        &:nth-child(2),&:nth-child(4)
          margin-right: 0;
          float: right;
    .input-box
      width: 95%;
      height: 45px;
      display: inline-block;
      border: 1px solid #ccc;
      border-radius: 5px;
      margin-bottom: 14px;
      padding: 0 2%;
      background: #ffffff;
      .phone-select-box
        width: 20%;
        display: inline-block;
        label
          position: relative;
          top: -1px;
          width: 100%;
          display: inline-block;
          height: 42px;
          line-height: 42px;
          &:after
            content: '';
            position: absolute;
            top: 40%;
            right: 0px;
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 10px solid #707372;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 15px;
          .el-select
            display: inline-block;
            position: absolute;
            width: 100%;
            left: 0;
            visibility: hidden;
            .el-input--suffix .el-input__inner
                padding: 0;
            .el-select .el-input__inner
                padding: 0;
            .el-input__inner
                padding: 0;
                outline: none;
                border: 0;
                caret-color: transparent;
            .el-input__suffix
                display: none;
      .phone-input-box
        width: 70%;
        padding-left: 2%;
        display: inline-block;
    .region-box
        label
            position: relative;
            top: 2px;
            display: inline-block;
            width: 100%;
            height: 42px;
            line-height: 42px;
            &:after
                content: '';
                position: absolute;
                top: 42%;
                right: 0px;
                width: 0;
                height: 0;
                border-left: 9px solid transparent;
                border-right: 9px solid transparent;
                border-top: 10px solid #707372;
                border-top-left-radius: 15px;
                border-top-right-radius: 15px;
                border-bottom-right-radius: 10px;
            .region-select
                color: #000;
                width: 100%;
                position: absolute;
                top: -1px;
                left: 0;
                visibility: hidden;
            .el-input--suffix .el-input__inner
                padding: 0;
            .el-select .el-input__inner
                padding: 0;
            .el-input__inner
                padding: 0;
                outline: none;
                border: 0;
                margin-top: 2px;
                font-weight: 600;
                font-size: 16px;
                caret-color: transparent;
            .el-input__suffix
                display: none;
    .weui-input
        height: 45px;
    .error_message
        color: #ff0000;
    .foreign_country_region_link
        margin-left: 8%;
        color: #d16a32;
        text-decoration: underline;
    .weui-agree
        padding: 5px 10%;
        position: relative;
        margin-top: 45px;
        .weui-agree__checkbox
            position: absolute;
            left: 5%;
            top: 9px;
            border-color: #d16a32;
        .weui-agree__checkbox:checked:before
            color: #d16a32;
            font-weight: 700;
            transform: translate(-50%, -54%) scale(0.73);
        .weui-agree__text
            display: inline-block;
            color: #000;
            a
                display: inline-block;
                color: #d16a32;
                font-weight: 600;
                text-decoration: underline;
        .weui-agree__fullstop
            color: #d16a32;
    .weui-btn-area
        margin: 0;
        padding: 45px 0;
        .weui-btn
            width: 70%;
            border-radius: 20px;
            background: #d16a32;
        .weui-btn:disabled
            background: #b3b2b2;

.checkName
    margin-bottom: 23px !important;

.el-select-group__title
    display: none;

.el-select-dropdown__item.selected
    color: #606266 !important;
    font-weight: 500 !important;
</style>



// WEBPACK FOOTER //
// src/views/SignUp.vue